import { render, staticRenderFns } from "./DetailApp.vue?vue&type=template&id=ed27dbec&scoped=true&"
import script from "./DetailApp.vue?vue&type=script&lang=js&"
export * from "./DetailApp.vue?vue&type=script&lang=js&"
import style0 from "./DetailApp.vue?vue&type=style&index=0&id=ed27dbec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed27dbec",
  null
  
)

export default component.exports